import config from '../config/index.js';
import { LOG_LEVELS, logMessage } from './logging.js';
import './navbar.js';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const name = document.getElementById('name').value.trim();
    const email = document.getElementById('email').value.trim();
    const message = document.getElementById('message').value.trim();

    try {
      const res = await fetch(`${config.detectionUrl}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });

      if (res.ok) {
        form.reset();
        alert('Thank you for reaching out!');
      } else {
        logMessage(LOG_LEVELS.ERROR, 'Contact form submission failed', {
          status: res.status,
        });
        alert('Submission failed. Please try again later.');
      }
    } catch (error) {
      logMessage(LOG_LEVELS.ERROR, 'Contact form submission error', {
        error: error.toString(),
      });
      alert('Submission failed. Please try again later.');
    }
  });
});
